<template>
    <b-col cols='12' sm='6' md='4' lg='3' xl='2' class='mt-2'>
      <b-card draggable>
        <b-form-row slot="header" id="head">
          <b-col>Happi (HAPPY) </b-col>
        </b-form-row>
          
         <b-form-row class="">
            <b-col cols='6' sm='12' md='12' lg='12' class="text-center"> 
                      <svg class="my-2" aria-hidden="true" preserveAspectRatio="xMidYMid meet" width="53" data-prefix="fas" id="smile" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path fill="currentColor" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"></path></svg>
                      <!-- <b-btn class="my-2" href="https://happy.btr.works" variant="outline-warning">Grab Happiness</b-btn> -->
            </b-col>
           
            <b-col cols='6' sm='12' md='12' lg='12'  class="text-center totals">
              <h6 v-if="!happy.amount>0">Get Some</h6>
              <h4 v-if="happy.amount>0" style="height:32px;">{{happy.amount}} (HAPPY)</h4>
            </b-col> 
          </b-form-row>  
      </b-card>    
    </b-col>  
</template>

<script>

// import Chart from 'chart.js'
import axios from 'axios'
export default {
  props: [ 'wallet' ],
  data: function () {
    return {
      happy: {
        level: 'Grab Some',
        amount: 0
      },
      status: 'updated',
      apiresponse: ''
    }
  },
  watch: {
    wallet () {
      this.getHappy(this.wallet)
    }
  },
  created () {
    console.log('IAMHERE')
    this.getHappy(this.wallet)
  },
  methods: {
    getHappy (address) {
      var url = 'https://api.ethplorer.io/getAddressInfo/' + address + '?apiKey=freekey'
      console.log('this Address:', url)
      axios.get(url)
      .then(response => {
        this.apiresponse = response.data.tokens
        console.log('APIDATA', this.apiresponse)
        for (let i = 0; i < this.apiresponse.length; i++) {
          console.log('Token:', i, this.apiresponse[i])
          if (this.apiresponse[i].tokenInfo.address === '0x5a567e28dbfa2bbd3ef13c0a01be114745349657') {
            this.happy.amount = this.apiresponse[i].balance / 100
            this.happy.level = 'Got Some'
          } else {
            this.happy.amount = 0
            this.happy.level = 'Need Some'
          }
        }
        return this.apiresponse
      })
      .catch(error => {
        console.log(error)
        return error
      })
    }
  },
  mounted () {
    // const ctx = document.getElementById(this.title)
    // this.myChart = new Chart(ctx, this.chartdata)
    // console.log('initial:', this.chartdata.data)
  }
}
</script>

<style scoped>
#head{
  padding-left: 1px;
  font-size: 100%;
}
.card-header{
  background-color:rgba(255, 192, 7, 1);
  font-family: 'Lato';
  word-break: break-word;
  font-size: 70%;
  color: white;
  padding: 3px;
  height: 25px;
}
#assetPriceBase{
  font-family: 'Lato';
  font-size: 125%;
  line-height: 1.2;
  padding: 0px;
}
#assetPercentBase{
  font-family: 'Lato';
  font-size: 60%;
}
#assetPrice{
  font-family: 'Lato';
  font-size: 80%;
}
.resolveToSymbol{
  font-family: 'Lato';
  font-size: 30%;
}
#assetPercent{
  font-family: 'Lato';
  font-size: 60%;
}
#assetTotalBase{
  font-family: 'Lato';
  font-size: 125%;
  line-height: 1;
  
}
#assetTotal{
  font-family: 'Lato';
  font-size: 80%;
  line-height: 1.5;
}

button{
  font-size: 0.9rem;
  padding: 2px;
  color: white;
}
.exchange{
  text-align: center;
  font-size: .7rem;
  color: grey;
}
.price{
  text-align: center;
  font-size: .8rem; 
}
.totals{
  padding-top: 5px;
  color: white;
  background: grey;
}
.close{
  color: white;
  background: none;
  font-size: 0.5rem;
  border: none;
  text-shadow: none;
  z-index: 1;
  opacity: 1;
}
.card-body{
  padding-top: 1px; 
  padding-left: 0.4rem; 
  padding-right: 0.4rem;
  padding-bottom: 1px;
} 
.input-group-prepend{
  width:300px;
}
#smile {
  display: block;
  margin: auto;
  color: rgba(255, 192, 7, 0.7)
}
</style>




// WEBPACK FOOTER //
// src/components/btr-happy.vue